<template>
<div id="login_az_app">
    <router-view></router-view>
</div>
</template>

<script>
import '@/assets/css/main.css'

export default {
    created() {
        var html_elements = document.getElementsByTagName('html');
        for (var i = 0; i < html_elements.length; i++) {
            html_elements[i].className = "main";
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/layouts/LoginLayout.vue